import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { noop } from '@ajaibid/utils';

import { PopUpCenter } from 'Component/PopUp';
import PaymentUpload from './PaymentUpload';
import SuccessUpload from './SuccessUpload';

const ModalUploadPayment = ({ isModalUpload, setIsModalUpload, transactionId }) => {
  const dispatch = useDispatch();
  const onHidePaymentUpload = () => {
    setIsModalUpload(false);
  };
  const [showSuccessPopup, setShowSuccessPopup] = useState(true);

  const successUpload = useSelector((state) => state.mfTransaction.onUploadedSuccess);
  const onUploaded = useSelector((state) => state.mfTransaction.onUploaded);

  return (
    <>
      <PopUpCenter show={isModalUpload} onHide={onHidePaymentUpload}>
        <PaymentUpload
          onHidePaymentUpload={onHidePaymentUpload}
          paymentId={transactionId}
          dispatch={dispatch}
          setIsShowPaymentUpload={setIsModalUpload}
          successUpload={successUpload}
          onUploaded={onUploaded}
        />
      </PopUpCenter>
      {successUpload && (
        <SuccessUpload
          showSuccessPopup={showSuccessPopup}
          onHideSuccessPopup={() => setShowSuccessPopup(false)}
        />
      )}
    </>
  );
};

ModalUploadPayment.propTypes = {
  isModalUpload: bool,
  setIsModalUpload: func,
  transactionId: string,
};

ModalUploadPayment.defaultProps = {
  isModalUpload: false,
  setIsModalUpload: noop,
  transactionId: '',
};

export default ModalUploadPayment;
